import { restApi } from '../../services/api';

export const getAgendamentos = async (queryString) => {
  return restApi.get(`relatorio-agendamentos?${queryString}`);
}
